<template>
  <div
    class="index-container"
    id="index-container"
    style="background-color: #fFFFFF"
  >
    <top-bar
      :showBack="true"
      @back="$router.go(-1)"
      :title="'青春校园'"
    ></top-bar>
    <div style="height: calc(100vh - 60px);overflow-y: auto">
      <div class="goid-page" v-if="gridDate">
        <div
          v-for="(item, index) in gridDate"
          :key="index"
          @click="gridCkick($event, item)"
          class="grid-item"
        >
          <div class="flex-column justify-content-start page-context">
            <img :src="item.img" style="width:100%;" />
            <p class="label">
              <em></em>
              {{ item.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <img src="@assets/home_new/bott2.jpg" style="width: 100vw;position: inherit" />
  </div>
</template>

<script>
import topBar from "../top-bar/index2";
import grid1 from "@/assets/images/qingchunxiaoyuan/grid1.png";
import grid2 from "@/assets/images/qingchunxiaoyuan/grid2.png";
import grid3 from "@/assets/images/qingchunxiaoyuan/grid3.png";
import grid4 from "@/assets/images/qingchunxiaoyuan/grid4.png";
import grid5 from "@/assets/images/qingchunxiaoyuan/grid5.png";
import grid6 from "@/assets/images/qingchunxiaoyuan/grid6.png";
import grid7 from "@/assets/images/qingchunxiaoyuan/grid7.png";

export default {
  name: "index",
  components: { topBar },
  data() {
    return {
      gridDate: [
        { img: grid1, path: "https://ccly.5idream.net/login", name: "返家乡" },
        { img: grid2, path: "https://kjcx.cydf.org.cn/", name: "小平实验室" },
        {
          img: grid3,
          path: "https://nm.tiaozhanbei.net/m293/matchflow/switch_level/",
          name: "挑战杯"
        },
        {
          img: grid4,
          path:
            "https://tzb.bocftsz.com/tzbjg/#/login?redirect=%2FfutContest%2FeligibilityReview%3Fuuid%3D1676526763963973636&matchLevel=2&initType=1&matchType=HKJ",
          name: "红色专项 黑科技平台"
        },
        {
          img: grid5,
          path: "https://zxb.chuangqingchun.net/matches/",
          name: "振兴杯"
        },
        {
          img: grid6,
          path: "http://xlxsh-mb.vysoft.top/nodata",
          name: "学联备案"
        },
        { img: grid7, path: "http://www.youth.cn/", name: "三下乡中青网备案" }
      ]
    };
  },
  created() {
    this.route = this.$route.query;
  },
  mounted() {},
  destroyed() {},
  methods: {
    gridCkick($event, item) {
      window.location = item.path;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";

.label {
  margin-top: 5px;
  color: #000000;
  font-weight: 500;
  background-color: #ffffff;
  font-size: 0.25rem;
  margin-left: 10px;
}

.label em {
  display: inline-block;
  width: 0.07rem;
  height: 0.26rem;
  border-radius: 0.035rem;
  background: #0c80ff;
  float: left;
  margin-right: 5px;
}

.page-context {
  font-weight: 600;
  font-size: 0.2rem;
}

.goid-page {
  background-color: #ffffff;
  margin: 0 10px;
  padding: 10px;
  height: 5rem;
  width: calc(100% - 20px);
  /*// padding: .86rem 0 .66rem 0;*/
  /*// background-color: #007aff50;*/
  display: grid;
  grid-template-columns: calc(50% - 5px) calc(50% - 5px);
  /*// grid-template-columns: repeat(auto-fill, 49%)*/
  grid-gap: 10px;
  grid-template-rows: calc(50% - 5px) calc(50% - 5px);
}

.grid-item {
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.index-container {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
